<template>
  <span
    class="key-label-feature"
    :style="{ backgroundColor: colour, color: textColor }"
  >
    {{ name }}
  </span>
</template>

<script setup>
const props = defineProps({
  name: { type: String, required: true },
  colour: { type: String, default: '#f3f4f6' }
});

function isColorDark(hex) {
  let c = hex.replace('#', '');
  if (c.length === 3) c = c.split('').map(x => x + x).join('');
  const r = parseInt(c.substr(0, 2), 16);
  const g = parseInt(c.substr(2, 2), 16);
  const b = parseInt(c.substr(4, 2), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
}

const textColor = computed(() => (isColorDark(props.colour) ? '#fff' : '#000'));
</script>

<style scoped lang="scss">
@import '@boats/ui/styles/config';

.key-label-feature {
  @include label-tag-2;
  display: inline-block;
  align-content: center;
  width: fit-content;
  padding: 0 6px;
  margin-right: 6px;
  border-radius: 90px;

  @include media-breakpoint-up(lg) {
    height: 30px;
    padding: 0 13px;
  }
}
</style>
